
export { SUPPORTED_LOCALES } from "./routes.constants"